<script lang="ts">
    import { appManager } from "../AppManagerStore";
    async function signin() {
        await $appManager.Authenticator.signinSilentCallback();
    }
</script>

{#await signin()}
    <div />
{/await}